import React, { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { createDataStore } from './data-store';
export var DataStoreContext = createContext(undefined);
export var DataStoreProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(DataStoreContext.Provider, { value: dataStore }, children));
};
export var dataStore = createDataStore();
export var useDataStore = function (selector) {
    var context = useContext(DataStoreContext);
    if (!context) {
        throw new Error("useDataStore must be used within DataStoreProvider");
    }
    return useStore(context, selector);
};
//# sourceMappingURL=data-store-provider.js.map